import { ThemeProvider, CssBaseline, Box } from '@mui/material';
import theme from './theme';
import Header from './components/Header';
import HeroCarousel from './components/HeroCarousel';
import ProductsSection from './components/ProductsSection';
import SchedulingSystemSection from './components/SchedulingSystemSection';
import AboutSection from './components/AboutSection';
import PartnersSection from './components/PartnersSection';
import Footer from './components/Footer';

function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Box
        sx={{
          minHeight: '100vh',
          display: 'flex',
          flexDirection: 'column',
        }}
      >
        <Header />
        <Box component="main" sx={{ flex: 1 }}>
          <HeroCarousel />
          <ProductsSection />
          <SchedulingSystemSection />
          <AboutSection />
          <PartnersSection />
        </Box>
        <Footer />
      </Box>
    </ThemeProvider>
  );
}

export default App;
